import React from "react";

const SvgMinus = props => <svg width={14} height={2} viewBox="0 0 14 2" fill="none" {...props}><line x1={0.838867} y1={0.982422} x2={13.6389} y2={0.982422} stroke="black" /></svg>;

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMiIgdmlld0JveD0iMCAwIDE0IDIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxsaW5lIHgxPSIwLjgzODg2NyIgeTE9IjAuOTgyNDIyIiB4Mj0iMTMuNjM4OSIgeTI9IjAuOTgyNDIyIiBzdHJva2U9ImJsYWNrIi8+Cjwvc3ZnPgo=";
export { SvgMinus as ReactComponent };